import { render } from "./EditBotConfiguration.vue?vue&type=template&id=bea7a8b8&scoped=true"
import script from "./EditBotConfiguration.vue?vue&type=script&lang=js"
export * from "./EditBotConfiguration.vue?vue&type=script&lang=js"

import "./EditBotConfiguration.vue?vue&type=style&index=0&id=bea7a8b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea7a8b8"]])

export default __exports__